<template>
  <div v-if="importData" class="w-full flex flex-col text-center">
    <FileUploadButton v-model:file="file"></FileUploadButton>
    <BudgetInfoImport v-model:importData="importData" v-model:fieldData="fieldData" :file :hide-inspection></BudgetInfoImport>
  </div>
  <div class="flex mt-2 justify-end">
    <SubmitButton label="Import" class="ml-auto" icon="file-import" @click="importBudget"></SubmitButton>
  </div>
</template>

<script setup lang="ts">
import SubmitButton from "@/components/global/buttons/SubmitButton.vue";
import { setBudgetImportInfo } from "@/services/ImportService";
import { toFormData2 } from "@/services/Utility";
import type { DrawItem } from "@/types/DrawItem";
import { type ImportBudgetFieldData, ImportBudgetFieldDataSchema, ImportBudgetSchema, type ImportBudget } from "@/types/Import";

const importData = defineModel<ImportBudget>("importData", { default: ImportBudgetSchema.parse({}) });
const fieldData = ref<ImportBudgetFieldData>(ImportBudgetFieldDataSchema.parse({}));

interface Props {
  hideInspection?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  hideInspection: false,
});

const emit = defineEmits<{
  importComplete: [importedItems: DrawItem[]];
}>();

//Was having an issue with display the name without having it as a separate ref, I hate this code
const file = ref<File | null>(null);

const importBudget = async (): Promise<void> => {
  if (importData.value == null) return;

  if (file.value == null) {
    error("File Missing", "An import file has not been selected");
    return;
  }
  if (importData.value.startRow > importData.value.endRow) {
    error("Invalid Value", "Start row may not be greater than the end row");
    return;
  }

  setBudgetImportInfo(importData.value, fieldData.value);

  const data = toFormData2(importData.value, "budgetData");
  data.append("file", file.value);

  await axios
    .post("/budgets/import", data, { headers: { "Content-Type": "multipart/form-data" } })
    .then((response) => {
      handleApiResponse(
        response,
        (data: any) => {
          emit("importComplete", response.data.result);
        },
        (errorlist: ApiError[]) => {
          for (let e of errorlist) {
            error("Import Error", e.message, 10000);
          }
        }
      );
    })
    .catch((e) => errorApi(e));
};
</script>
